import(/* webpackMode: "eager" */ "/src/src/app/[locale]/auth/login/page.tsx");
